import React, { Component } from 'react'
import loader from '../../images/loader.svg'

export default class Loading extends React.Component{

  constructor(props) {
    super(props)
    this.state = {
      show: props.show,
    }
  }
  render(){
    return(
      <div className={this.state.show ? 'loading-container' : 'hidden'}>
        <img src={loader} width='100' />
        <div>Betöltés</div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/loading.js